export default "__VITE_ASSET__52073ecf__"